import {
  HttpAnswerProp,
  HttpLineDemandSurveyAnswer,
  ILineDemandSurveyAnswerParser,
} from "../surveyRepository.types";
import { err, ok, Result } from "neverthrow";
import { ParseError } from "@/repositories/shared/errors/parseError";
import { injectable } from "inversify";
import { IAnswerProp, ILineDemandSurveyAnswer } from "@/domain/entities/survey";

function parseAnswerProp(prop: HttpAnswerProp): IAnswerProp {
  const answerProp: IAnswerProp = {
    no: prop.no,
    label: prop.label,
    type: prop.type,
    inputValue: prop.inputValue,
    selected: prop.selected,
    selectValue: prop.selectValue,
  };

  return answerProp;
}

function toHttpAnswerProp(answerProp: IAnswerProp): HttpAnswerProp {
  const httpAnswerProp = {
    no: answerProp.no,
    label: answerProp.label,
    type: answerProp.type,
    inputValue: answerProp.inputValue,
    selected: answerProp.selected,
    selectValue: answerProp.selectValue,
  };

  return httpAnswerProp;
}

@injectable()
export class LineDemandSurveyAnswerParser
  implements ILineDemandSurveyAnswerParser
{
  constructor() {}

  toDomain(
    data: HttpLineDemandSurveyAnswer | undefined
  ): Result<ILineDemandSurveyAnswer | undefined, ParseError> {
    try {
      if (!data) return ok(undefined);

      const lineDemandSurveyAnswer: ILineDemandSurveyAnswer = {
        serviceUid: data.serviceUid,
        surveyUid: data.surveyUid,
        userUid: data.userUid,
        targetDate: data.targetDate,
        answerProps: data.answerProps?.map(parseAnswerProp),
        savedTs: data.savedTs,
        savedUid: data.savedUid,
      };

      return ok(lineDemandSurveyAnswer);
    } catch (error: any) {
      return err(new ParseError(error.message));
    }
  }

  fromDomain(props: IAnswerProp[]): HttpAnswerProp[] | ParseError {
    try {
      const answerProps: HttpAnswerProp[] = props.map(toHttpAnswerProp);
      return answerProps;
    } catch (error: any) {
      return new ParseError(error.message);
    }
  }
}
